<template>
  <label class="d-flex align-items-center justify-content-between m-0">
    <span>Design Studio v2</span>
    <b-form-checkbox
      switch
      class="ml-3 mb-0"
      :checked="ds2"
      :disabled="toggling"
      @change="onChange"
    />
  </label>
</template>

<script>
export default {
  name: 'DesignStudioV2Toggle',
  data() {
    return {
      toggling: false,
    }
  },
  computed: {
    ds2() {
      return this.$store.getters['user/ds2']
    },
  },
  methods: {
    async onChange(enabled) {
      this.$emit('change', enabled)
      this.toggling = true
      try {
        await this.$store.dispatch('user/setDs2', enabled)
      } catch (err) {
        this.$alert.simple(err)
      } finally {
        this.toggling = false
      }
    },
  },
}
</script>
